<template lang="html">
  <div class="main-div">
    <div v-if="showLoader" class="container">
      <div class="loader-container">
        <loader></loader>
      </div>
    </div>
    <template v-else>
      <not-anonymous-task-message @close="close" v-if="notAnonymous"></not-anonymous-task-message>
      <template v-else>
        <question-welcome @close="close"  @next="next" v-if="activeQuestionIndex === 0"></question-welcome>
        <input-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(1)"></input-question>
        <multiselect-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(2)"></multiselect-question>
        <file-upload-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(3)"></file-upload-question>
        <location-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(4)"></location-question>
        <address-question @close="close" :index="questionIndex" @previous="prev"  @next="next" v-if="questionType(5)"></address-question>
        <vote-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(6)"></vote-question>
        <skill-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(7)"></skill-question>
        <min-max-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(8)"></min-max-question>
        <hyperlink-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(9)"></hyperlink-question>
        <date-question  @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(10)"></date-question>
        <multiline-question @close="close" :index="questionIndex" @previous="prev" @next="next" v-if="questionType(11)"></multiline-question>
        <template v-if="questionTypeAtIndex[activeQuestionIndex] === 12">
          <question-direct-completion-thanks v-if="directQuestionaire"></question-direct-completion-thanks>
          <question-thanks v-else></question-thanks>
        </template>

        <div class="branding" >
          <a v-if="directQuestionaire" href="https://www.organizedeffort.com" target="_blank">
            <img src="../assets/logo.svg" alt="Logo" height="50">
          </a>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import MinMaxQuestion from '@/components/QuestionsTypes/MinMaxQuestion';
import QuestionWelcome from '@/components/QuestionsTypes/QuestionWelcome';
import InputQuestion from '@/components/QuestionsTypes/InputQuestion';
import MultiselectQuestion from '@/components/QuestionsTypes/MultiselectQuestion';
import SkillQuestion from '@/components/QuestionsTypes/SkillQuestion';
import QuestionThanks from '@/components/QuestionsTypes/QuestionThanks';
import AddressQuestion from '@/components/QuestionsTypes/Address';
import HyperlinkQuestion from '@/components/QuestionsTypes/Hyperlink';
import FileUploadQuestion from '@/components/QuestionsTypes/FileUpload';
import VoteQuestion from '@/components/QuestionsTypes/Vote';
import LocationQuestion from '@/components/QuestionsTypes/LocationQuestion';
import DateQuestion from '@/components/QuestionsTypes/DateQuestion';
import MultilineQuestion from '@/components/QuestionsTypes/MultilineQuestion';
import QuestionDirectCompletionThanks from '@/components/QuestionsTypes/QuestionDirectCompletionThanks';
import NotAnonymousTaskMessage from '@/components/QuestionsTypes/NotAnonymousTaskMessage';
import Loader from '@/components/Loader';

export default {
  components: {
    Loader,
    QuestionWelcome,
    MultiselectQuestion,
    InputQuestion,
    DateQuestion,
    SkillQuestion,
    QuestionThanks,
    AddressQuestion,
    HyperlinkQuestion,
    FileUploadQuestion,
    VoteQuestion,
    LocationQuestion,
    MinMaxQuestion,
    MultilineQuestion,
    QuestionDirectCompletionThanks,
    NotAnonymousTaskMessage,
  },
  props: {
    directQuestionaire: { type: Boolean, default: false },
    taskType: { type: String, default: '0' },
    showLoader: { type: Boolean, default: false },
  },
  data() {
    return {
      activeQuestionIndex: 0,
    };
  },
  computed: {
    questionIndex() {
      // we need to show the welcome, [......], final screen
      // so in order for the question to pick the right value we subract one from the data
      return this.activeQuestionIndex - 1;
    },
    notAnonymous() {
      return this.taskType === '0' && this.directQuestionaire;
    },
    questionTypeAtIndex() {
      return this.$store.getters['completionQuestions/questionTypeIndexArray'];
    },
  },
  methods: {
    next() {
      this.activeQuestionIndex += 1;
    },
    prev() {
      this.activeQuestionIndex -= 1;
    },
    close() {
      this.$emit('close');
    },
    questionType(type) {
      return this.questionTypeAtIndex[this.activeQuestionIndex] === type;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";
.loader-class {
  align-self: center;
}

.main-div {
  height: 100%;
  background: white;
}

.container {
  padding: 12px;
  -webkit-box-shadow: 0 4px 8px 0 rgba(226, 3, 3, 0.5);
  box-shadow: 0 4px 8px 0 rgba(226, 3, 3, 0.5);
  background: white;
  height: 100%;
  width: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: center;
  border-radius: 12px;
  overflow-y: auto;
}
.loader-container {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.branding {
  text-align: center;
  background: white;
  height: 50px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue